function Utils() {
  let timer = null;
  this.throttle = function (func, wait = 300, immediate = true) {
    if (!timer) {
      if (immediate) {
        typeof func === "function" && func();
        timer = setTimeout(() => {
          timer = null;
        }, wait);
      } else {
        timer = setTimeout(() => {
          timer = null;
          typeof func === "function" && func();
        }, wait);
      }
    }
  };
}


const utils = new Utils();
export default utils;
